import { useSelector } from "react-redux";
import { IRootState } from "../../types/redux/IRootStore";
import { aplSettingsFromState } from "./aplSettingsHelper";

const AplSettingsSelector = () => {
    const state = useSelector((state: IRootState) => state);
    return aplSettingsFromState(state);
};

export default AplSettingsSelector;
